import { monitorPlatformSupport } from '../constants/monitorPlatformSupport';

export const checkMonitorAvailability = (monitor: MonitorRule, platform: Platform) =>
    monitorPlatformSupport[monitor][platform].supported;
